/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScanSessionResultModel } from '../../models/scan-session-result-model';

export interface ScanSessionHistoryProfileIdGet$Params {

/**
 * The unique identifier of the profile
 */
  profileId: string;

/**
 * The start date for the history period
 */
  fromDate?: string;

/**
 * The end date for the history period
 */
  toDate?: string;
}

export function scanSessionHistoryProfileIdGet(http: HttpClient, rootUrl: string, params: ScanSessionHistoryProfileIdGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<Array<ScanSessionResultModel>>> {
  const rb = new RequestBuilder(rootUrl, scanSessionHistoryProfileIdGet.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<Array<ScanSessionResultModel>>;
    })
  );
}

scanSessionHistoryProfileIdGet.PATH = '/Scan/SessionHistory/{profileId}';
